import React from 'react';
import { ProviderInfoListBox } from '@kyruus/provider-components';

import { Log } from 'Src/types';
import {
  NUMBER_OF_COLUMNS,
  TRUNCATE,
  SHOW_SEARCH_ITEMS_THRESHOLD,
  COLUMN_ROW_BREAK
} from './constants';
import { ContentSection, ContentList, SectionHeader } from './styles';

interface ListProps {
  data: { name: string }[];
  id: string;
  log: Log;
  searchInputTitle: string;
  title: string;
  titleId: string;
}

export const List = ({
  data,
  id,
  log,
  searchInputTitle,
  title,
  titleId
}: ListProps) => (
  <ContentSection aria-labelledby={titleId}>
    <SectionHeader id={titleId}>{title}</SectionHeader>
    <ContentList>
      <ProviderInfoListBox
        id={id}
        data-testid={`location-list-${id}`}
        itemType={title}
        searchInputTitle={searchInputTitle}
        items={data}
        showClearSearchIcon={true}
        numColumns={data.length > COLUMN_ROW_BREAK ? NUMBER_OF_COLUMNS : 1}
        log={log}
        truncateAt={TRUNCATE}
        isV9Profile={true}
        showSearch={data.length > SHOW_SEARCH_ITEMS_THRESHOLD}
      />
    </ContentList>
  </ContentSection>
);
